import { addCompare, removeCompare } from '@/js/api/compare.ts';
import { getLocaleValue } from '@/js/helper/locale.ts';
import { ERROR_REQUEST_TEXT, getNotificationElement, showErrorNotify, showSuccessNotify } from '@/js/notification.ts';
import { computed, ref, watch } from 'vue';

const QUANTITY_SELECTOR = '.js-compare-quantity';
const compareElement = document.querySelector<HTMLElement>(QUANTITY_SELECTOR);

export function useCompare() {
  const quantity = ref(0);
  const initialCounter = computed(() => compareElement?.dataset.counter ?? null);
  watch(initialCounter, (counter) => {
    quantity.value = counter !== null ? Number(counter) : 0;
  }, {
    immediate: true,
  });

  watch(quantity, (nextQuantity) => {
    compareElement?.setAttribute('data-counter', nextQuantity.toString());
  });
  async function add(productId: number) {
    try {
      await addCompare(productId);
      quantity.value += 1;
      showSuccessNotify({ node: getNotificationElement(getLocaleValue('product_added_to'), getLocaleValue('your_comparison_list'), '/compare') });
    }
    catch (e) {
      showErrorNotify({ text: ERROR_REQUEST_TEXT });
      console.log(e);
    }
  }

  async function remove(productId: number) {
    try {
      await removeCompare(productId);
      if (quantity.value > 0) {
        quantity.value -= 1;
      }
      showErrorNotify({ text: getLocaleValue('product_has_been_removed_from_the_comparison_list') });
    }
    catch (e) {
      showErrorNotify({ text: ERROR_REQUEST_TEXT });
      console.log(e);
    }
  }

  return {
    add,
    remove,
  };
}
